import { prop } from "fw";

let id = 0;

export class Modal {
    @prop(null) width;
    @prop(840) maxWidth: number;
    @prop(null) dataId;

    uniqueId = "modal-" + id++;
}
